<!-- Loading Overlay -->
<div *ngIf="isLoading" class="loading-overlay fixed inset-0 flex flex-col items-center justify-center bg-black/50 z-50">
    <div class="bg-white rounded-lg p-6 shadow-lg flex flex-col items-center max-w-md w-full">
        <h2 class="text-xl font-semibold mb-4">Loading</h2>
        <p-progressBar [mode]="'indeterminate'" [style]="{ height: '6px' }" class="w-full mb-4"></p-progressBar>
        <p class="text-gray-600">Please wait...</p>
    </div>
</div>
